module.exports = __webpack_public_path__ + "static/img/404_listing.cfb49f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404_listing.svg
// module id = JNhL
// module chunks = 1